import { theme, Typography } from 'antd';

/**
 * O trecho onde o termo foi encontrado, com o achado destacado.
 *
 * **Renderiza texto, e não HTML.** O destaque vem do banco entre `[[[` e `]]]`,
 * e não como marcação, justamente para esta tela nunca precisar injetar HTML
 * vindo de conteúdo. O texto guardado teve as etiquetas removidas por expressão
 * regular, e expressão regular não fecha a porta: um `<img src=x onerror=...`
 * sem o `>` final atravessa a limpeza, e uma etiqueta de destaque colada depois
 * completaria a tag no navegador. Aqui os pedaços viram nós de texto do React,
 * que escapa tudo por construção.
 *
 * O marcador é improvável em texto jurídico; se aparecer por acaso, o pior que
 * acontece é um destaque a mais - nunca uma tag.
 */
const ABRE = '[[[';
const FECHA = ']]]';

/** Quebra o trecho em pedaços comuns e pedaços destacados, em ordem. */
export function pedacosDoTrecho(trecho: string): { texto: string; achado: boolean }[] {
  const pedacos: { texto: string; achado: boolean }[] = [];
  let resto = trecho;

  while (resto.length > 0) {
    const inicio = resto.indexOf(ABRE);
    if (inicio < 0) {
      pedacos.push({ texto: resto, achado: false });
      break;
    }

    const fim = resto.indexOf(FECHA, inicio);
    if (fim < 0) {
      // Marcador aberto e não fechado: trata como texto comum em vez de
      // engolir o resto do trecho.
      pedacos.push({ texto: resto, achado: false });
      break;
    }

    if (inicio > 0) pedacos.push({ texto: resto.slice(0, inicio), achado: false });
    pedacos.push({ texto: resto.slice(inicio + ABRE.length, fim), achado: true });
    resto = resto.slice(fim + FECHA.length);
  }

  return pedacos.filter((pedaco) => pedaco.texto.length > 0);
}

export function TrechoEncontrado({ trecho }: { trecho: string }) {
  const { token } = theme.useToken();

  return (
    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
      ...{' '}
      {pedacosDoTrecho(trecho).map((pedaco, indice) =>
        pedaco.achado ? (
          <mark
            key={indice}
            style={{
              background: token.colorWarningBg,
              color: token.colorText,
              padding: '0 2px',
              borderRadius: 2,
            }}
          >
            {pedaco.texto}
          </mark>
        ) : (
          <span key={indice}>{pedaco.texto}</span>
        ),
      )}{' '}
      ...
    </Typography.Text>
  );
}
